import { useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import Actionbar from 'src/components/common/actionbar/Authactionbar';
import { Message } from 'src/components/common/form/Message';
import useUiuxStore from 'src/store/useUiuxStore';
import { Content_EQM3010_R01 } from './Content_EQM3010_R01';
import { EQM3010_R01Dto } from './Dto_EQM3010_R01';
import { SearchSection_EQM3010_R01 } from './SearchSection_EQM3010_R01';
import { useEQM3010_R01Store } from './Store_EQM3010_R01';
import { Table_EQM3010_R01 } from './Table_EQM3010_R01';

export const Container_EQM3010_R01 = () => {
	const { setMessage } = useUiuxStore();
	const { initData } = useEQM3010_R01Store();
	const gridRef = useRef<AgGridReact<EQM3010_R01Dto>>(null);

	const {
		clickable, setClickable,
		fetchData,
		handleExcelClick,
		handleInsertClick,
		handleSaveClick,
		handleDeleteClick,
		handleCopyPreviousYear,
	} = Content_EQM3010_R01({ gridRef, setMessage });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={handleInsertClick}
				onDeleteClick={handleDeleteClick}
				onSaveClick={handleSaveClick}
				onInitClick={initData}
				onExcelClick={handleExcelClick}
			/>
			<SearchSection_EQM3010_R01 onCopyPreviousYear={handleCopyPreviousYear} />
			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_EQM3010_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
					/>
				</div>
			</div>
			<Message />
		</div>
	);
};
